import React, {useContext} from "react";
import {motion} from "framer-motion";
import "./Achievement.scss";
import {achievementSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, staggerCards, cardItem, vp} from "../../utils/animations";

export default function Achievement() {
  const {isDark} = useContext(StyleContext);
  if (!achievementSection.display) return null;

  return (
    <motion.section
      className={`certs ${isDark ? "dark" : ""}`}
      id="achievements"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="certs__inner">
        <motion.div className="certs__header" variants={fadeUp}>
          <span className="section-label">Certifications</span>
          <h2 className="certs__title">{achievementSection.title}</h2>
        </motion.div>

        <motion.div
          className="certs__list"
          variants={staggerCards}
          initial="hidden"
          whileInView="show"
          viewport={{once: true, amount: 0.05}}
        >
          {achievementSection.achievementsCards.map((c, i) => (
            <motion.div key={i} className="cert" variants={cardItem}>
              <div className="cert__logo-wrap">
                <img src={c.image} alt={c.imageAlt} className="cert__logo" />
              </div>

              <div className="cert__body">
                <div className="cert__meta">
                  <span className="cert__issuer">{c.issuer}</span>
                  {c.year && (
                    <>
                      <span className="cert__sep">·</span>
                      <span className="cert__year">{c.year}</span>
                    </>
                  )}
                </div>
                <h3 className="cert__title">{c.title}</h3>
                <p className="cert__sub">{c.subtitle}</p>
                {c.footerLink && c.footerLink.length > 0 && (
                  <div className="cert__links">
                    {c.footerLink.map((l, j) => (
                      <a
                        key={j}
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cert__link"
                      >
                        {l.name} ↗
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
}
